import { render, staticRenderFns } from "./indexPop.vue?vue&type=template&id=6ea210e5&"
import script from "./indexPop.vue?vue&type=script&lang=ts&"
export * from "./indexPop.vue?vue&type=script&lang=ts&"
import style0 from "./indexPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports